export default {
    alert_1: "Nasadili sme novú verziu! Viac o verzii {version} si prečítaš v ",
    alert_2: "changelogu.",

    text_0: "Alert pre používateľov o novej verzii nastavený.",
    text_1: "História verzií",
    text_2: "Zoznám verzií",
    text_3: "Changelog alert",
    text_4: "Verzia",
    text_5: "V.{version}",
    text_6: "Nová funkcia",
    text_7: "Oprava chyby",
    text_8: "Zmena",
};
